/**
 * Authentication provider component.
 * Validates auth on mount for returning users. Dashboard is public by default.
 */

import { useEffect, type ReactNode } from 'react';
import { validateAuth } from '../../services/authApi';

interface AuthProviderProps {
  children: ReactNode;
}

/**
 * Auth provider that wraps the app.
 * Validates stored credentials on mount (non-blocking).
 * Dashboard renders immediately - auth state used for conditional admin features.
 */
export function AuthProvider({ children }: AuthProviderProps) {
  useEffect(() => {
    // Validate auth on mount (non-blocking)
    // If valid token exists, admin features will appear
    // If not, user sees public dashboard
    validateAuth();
  }, []);

  return <>{children}</>;
}
